import { getJson, postJson } from './client'
import type { BenchmarkView, OutreachPersonView, OutreachView } from '../types/outreach'
import type { JobView } from '../types/voice'

// Outreach: who to contact today and why, one person opened, and the brief about that person as a job.
// The queue is org-scoped like every list (the client appends ?org= on every GET); the drawer and the
// brief are read from the signed-in person's own mailbox, whichever org they are looking at.
const outreach = (spoke: string) => `/api/spokes/${encodeURIComponent(spoke)}/scout/outreach`

export const outreachApi = {
  list: (spoke: string) => getJson<OutreachView>(outreach(spoke)),
  person: (spoke: string, personId: string) => getJson<OutreachPersonView>(`${outreach(spoke)}/${encodeURIComponent(personId)}`),
  /** Starts the person-research job (202 + the job); one at a time, re-runnable. */
  research: (spoke: string, personId: string) => postJson<JobView>(`${outreach(spoke)}/${encodeURIComponent(personId)}/research`),
  /** His bands against Scout's, for one priority-contacts import (PL-125). Read-only. */
  benchmark: (spoke: string, batchId: string) => getJson<BenchmarkView>(`${outreach(spoke)}/benchmark?batchId=${encodeURIComponent(batchId)}`),
}
